import { render, staticRenderFns } from "./WorkflowMa.vue?vue&type=template&id=f7aa542a&scoped=true"
import script from "./WorkflowMa.vue?vue&type=script&lang=ts"
export * from "./WorkflowMa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7aa542a",
  null
  
)

export default component.exports